<template>
  <div class="dashboard-page">
    <section class="dashboard-hero">
      <div>
        <p class="eyebrow">TEACHER DASHBOARD</p>
        <h1>考试管理看板</h1>
        <span>统一管理题库、试卷、考试发布与成绩批改</span>
      </div>
      <div class="server-panel">
        <div class="server-panel__title">
          <strong>服务状态</strong>
          <el-switch v-model="showStatus"></el-switch>
        </div>
        <div class="server-metric">
          <span>CPU</span>
          <el-progress :text-inside="true" :stroke-width="20" :percentage="server_status.cpu_per"></el-progress>
        </div>
        <div class="server-metric">
          <span>MEMORY</span>
          <el-progress :text-inside="true" :stroke-width="20" :percentage="server_status.memory_per"
                       status="success"></el-progress>
        </div>
      </div>
    </section>

    <section class="stat-grid">
      <article class="stat-card" v-for="item in statCards" :key="item.label">
        <div class="stat-icon">
          <i :class="item.icon"></i>
        </div>
        <div>
          <p>{{ item.label }}</p>
          <strong>{{ item.value }}</strong>
        </div>
      </article>
    </section>

    <section class="chart-grid">
      <el-card class="chart-card">
        <div slot="header" class="chart-header">
          <strong>题库题型占比</strong>
          <span>Question Types</span>
        </div>
        <div id="main2" class="chart-box"></div>
      </el-card>
      <el-card class="chart-card">
        <div slot="header" class="chart-header">
          <strong>最近一次考试前五名</strong>
          <span>Top Scores</span>
        </div>
        <div id="main1" class="chart-box"></div>
      </el-card>
    </section>
    <div class="app-footer">© 海之林科技 在线考试系统</div>
  </div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  name: "TeacherIndex",
  data() {
    return {
      chart1: null,
      chart2: null,
      title_type_list: [],
      name_list: [],
      score_list: [],
      showStatus: false,
      timer: null,
      timer1: null,
      dataCount: {
        student_count: 0,
        title_count: 0,
        paper_count: 0,
        task_count: 0,
      },
      server_status: {
        cpu_per: 0,
        memory_per: 0,
      },
      chartInstance: null,
    }
  },
  computed: {
    statCards() {
      return [
        {label: '试卷总数', value: this.dataCount.paper_count, icon: 'el-icon-document-copy'},
        {label: '试题总数', value: this.dataCount.title_count, icon: 'el-icon-edit-outline'},
        {label: '考试总数', value: this.dataCount.task_count, icon: 'el-icon-s-promotion'},
        {label: '学生总数', value: this.dataCount.student_count, icon: 'el-icon-medal-1'},
      ]
    }
  },
  created() {
    this.getServerStatus()
    this.getDataCount()
    this.getCategory()
  },
  watch: {
    "showStatus": function () {
      if (this.showStatus) {
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          this.getServerStatus()
        }, 1000)
      } else {
        clearInterval(this.timer)
      }
    }
  },
  methods: {
    getServerStatus() {
      this.$http({
        url: this.$settings.BASE_URL + '/user/teacher_index/server_status/',
        method: 'get',
      }).then(res => {
        if (res.data.code === 20000) {
          this.server_status = res.data.server_status
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            duration: 3000,
          })
        }
      })
    },
    getDataCount() {
      this.$http({
        url: this.$settings.BASE_URL + '/user/teacher_index/data_count/',
        method: 'get',
      }).then(res => {
        if (res.data.code === 20000) {
          this.dataCount = res.data.result
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            duration: 3000,
          })
        }
      })
    },
    getCategory() {
      this.$http({
        url: this.$settings.BASE_URL + '/user/teacher_index/title_type/',
        method: 'get',
      }).then(res => {
        if (res.data.code === 20000) {
          this.title_type_list = res.data.result
          this.name_list = res.data.names
          this.score_list = res.data.scores
        }
      })
    },
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    // var myChart_3 = echarts.init(document.getElementById('main3'));
    // 使用刚指定的配置项和数据显示图表。
    // myChart_3.setOption(this.option_3);
    clearInterval(this.timer1)
    let i = 0
    this.timer1 = setInterval(() => {
      i++
      this.chart1 = echarts.init(document.getElementById('main1'));
      this.chart2 = echarts.init(document.getElementById('main2'));
      let option1 = {
        color: ['#2aa5dc'],
        tooltip: {},
        xAxis: {
          data: this.name_list,
          axisLine: {lineStyle: {color: '#d7e5ed'}},
          axisLabel: {color: '#5d778d'}
        },
        yAxis: {
          axisLabel: {color: '#5d778d'},
          splitLine: {lineStyle: {color: '#edf3f7'}}
        },
        grid: {left: 36, right: 20, top: 28, bottom: 34},
        series: [{
          name: '考生分数',
          type: 'bar',
          data: this.score_list,
          barWidth: 24,
          itemStyle: {borderRadius: [8, 8, 0, 0]}
        }]
      }
      let option2 = {
        color: ['#1878bd', '#2aa5dc', '#13a889', '#8ab6d6', '#f2b84b'],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: 0,
          textStyle: {color: '#5d778d'}
        },
        series: [
          {
            name: '题目数量',
            type: 'pie',
            radius: ['42%', '66%'],
            center: ['50%', '45%'],
            data: this.title_type_list,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.chart1.setOption(option1);
      this.chart2.setOption(option2);
      if (i === 1) {
        clearInterval(this.timer1)
      }
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.timer1)
  }
}
</script>

<style scoped>
.dashboard-page {
  color: #173a58;
}

.dashboard-hero {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 22px;
  align-items: stretch;
  padding: 28px;
  border-radius: 24px;
  color: #fff;
  background:
      radial-gradient(circle at 82% 20%, rgba(255, 255, 255, 0.18), transparent 28%),
      linear-gradient(135deg, #103a63, #1878bd);
  box-shadow: 0 18px 40px rgba(24, 120, 189, 0.22);
}

.eyebrow {
  margin-bottom: 14px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.dashboard-hero h1 {
  margin-bottom: 12px;
  font-size: 34px;
  letter-spacing: 0.03em;
}

.dashboard-hero span {
  color: rgba(255, 255, 255, 0.78);
  font-size: 16px;
}

.server-panel {
  padding: 22px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.server-panel__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.server-metric + .server-metric {
  margin-top: 16px;
}

.server-metric span {
  display: block;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  margin: 22px 0;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px;
  border-radius: 20px;
  background: #fff;
  border: 1px solid rgba(219, 232, 239, 0.92);
  box-shadow: 0 12px 32px rgba(28, 93, 141, 0.08);
}

.stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  color: #fff;
  font-size: 24px;
  background: linear-gradient(135deg, #1878bd, #2aa5dc);
}

.stat-card p {
  margin-bottom: 6px;
  color: #71889a;
  font-size: 14px;
}

.stat-card strong {
  color: #103a63;
  font-size: 30px;
}

.chart-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px;
}

.chart-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.chart-header strong {
  color: #173a58;
  font-size: 17px;
}

.chart-header span {
  color: #8aa0af;
  font-size: 12px;
  letter-spacing: 0.12em;
}

.chart-box {
  height: 360px;
  width: 100%;
}

@media (max-width: 1100px) {
  .dashboard-hero,
  .chart-grid {
    grid-template-columns: 1fr;
  }

  .stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .stat-grid {
    grid-template-columns: 1fr;
  }
}
</style>
